import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { surfaceCard } from '../../../../Shared/surfaceCard';

const JobDueDate = ({ dueDate, onDueDateChange, variant = 'card' }) => {
	const theme = useTheme();
	const isHero = variant === 'hero';

	const picker = (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<DatePicker
				value={dueDate ? dayjs(dueDate) : null}
				onChange={(date) => {
					onDueDateChange(date ? date.format('YYYY-MM-DD') : null);
				}}
				slotProps={{
					textField: {
						fullWidth: !isHero,
						size: 'small',
						placeholder: 'Not set',
						helperText: isHero
							? undefined
							: 'Expected project completion date.',
						sx: isHero
							? {
									maxWidth: { xs: 148, sm: 156 },
									'& .MuiInputBase-input': {
										fontSize: '0.8125rem',
										py: 0.75,
									},
									'& .MuiOutlinedInput-root': {
										bgcolor: (t) =>
											t.palette.mode === 'dark'
												? 'rgba(255,255,255,0.04)'
												: 'rgba(0,0,0,0.02)',
									},
								}
							: undefined,
					},
					field: { clearable: true },
				}}
			/>
		</LocalizationProvider>
	);

	if (isHero) {
		return (
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'flex-start',
					gap: 0.5,
					flexShrink: 0,
				}}
			>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: 0.5,
					}}
				>
					<EventOutlinedIcon sx={{ fontSize: 15, color: 'text.secondary' }} />
					<Typography
						variant="caption"
						sx={{
							fontWeight: 600,
							color: 'text.secondary',
							textTransform: 'uppercase',
							letterSpacing: 0.5,
							fontSize: '0.65rem',
						}}
					>
						Due
					</Typography>
				</Box>
				{picker}
			</Box>
		);
	}

	return (
		<Box sx={{ ...surfaceCard(theme), p: 2 }}>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
				<EventOutlinedIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
				<Typography variant="subtitle2" fontWeight={700}>
					Due date
				</Typography>
			</Box>
			{picker}
		</Box>
	);
};

export default JobDueDate;
